import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Awards from 'project/components/awards';
import { toggleAwardsModal, toggleAssureModal } from 'project/ducks/awards';
import { canAddAwards } from 'project/utils';


export function mapStateToProps(state) {
  const { project } = state;
  const projectData = project.projectPage.project.data;
  const canEdit = canAddAwards(state);
  const awards = projectData.award_rules.filter(({ feature }) => feature.position > 0).map(({ feature }) => feature);

  return {
    project: projectData,
    awards,
    canEdit
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    toggleModal: toggleAwardsModal,
    toggleAssureModal
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Awards);



// WEBPACK FOOTER //
// ./project/containers/awards.js